import DomainVerification from "./DomainVerification.container";
export default DomainVerification;
